import { FileCategories } from '@/types/api';

export const labelByFileCategories: Record<FileCategories, string> = {
  [FileCategories.AGREEMENTS]: 'Agreements',
  [FileCategories.CONTRACT]: 'Contract',
  [FileCategories.CONTRACTS]: 'Contracts',
  [FileCategories.COVER_LETTER]: 'Cover Letter',
  [FileCategories.DOCUMENTS]: 'Documents',
  [FileCategories.FORMATTED_RESUME]: 'Formatted resume',
  [FileCategories.OFFER]: 'Offer',
  [FileCategories.OTHER]: 'Others',
  [FileCategories.RESUME]: 'Resume',
};

export const formatFileSize = (fileSize: number): string => {
  if (fileSize === 0) return '0 Bytes';

  const kiloByte = 1024;
  const units = ['Bytes', 'Kb', 'Mb', 'Gb'];

  const formattedSize = Math.floor(Math.log(fileSize) / Math.log(kiloByte));

  return `${parseFloat((fileSize / kiloByte ** formattedSize).toFixed(2))} ${units[formattedSize]}`;
};
